<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
      <div class="ete-msg items-center">
        <p>Messages you send to this chat are secured with end-to-end encryption.</p>
      </div>
      <div id="component-chat-log" class="m-8" v-if="chatData">
        <div v-for="(msg, index) in chatData" class="msg-grp-container" :key="index">

            <!-- If previous msg is older than current time -->
            <template v-if="chatData[index-1]">
                <vs-divider v-if="!isSameDay(chatData[index].createdAt, chatData[index-1].createdAt)" class="msg-time">
                    <span>{{ toDate(msg.createdAt) }}</span>
                </vs-divider>
                <!-- <div class="spacer mt-8" v-if="!hasSentPreviousMsg(chatData[index-1].isSent, msg.isSent)"></div> -->
            </template>

            <div class="flex items-start" :class="[{'flex-row-reverse' : isSent(msg)}]">

                <!-- <template v-if="chatData[index-1]">
                    <template v-if="(!hasSentPreviousMsg(chatData.msg[index-1].isSent, msg.isSent) || !isSameDay(msg.time, chatData.msg[index-1].time))">
                        <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :class="msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'" :src="senderImg(msg.isSent)"></vs-avatar>
                    </template>
                </template> -->

                <!-- <template v-if="index == 0">
                    <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :class="isSent(msg) ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'" :src="senderImg(isSent(msg))"></vs-avatar>
                </template> -->

                <!-- <template v-if="chatData.msg[index-1]">
                    <div class="mr-16" v-if="!(!hasSentPreviousMsg(chatData.msg[index-1].isSent, msg.isSent) || !isSameDay(msg.time, chatData.msg[index-1].time))"></div>
                </template> -->

                <div class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm" :class="{'bg-primary-gradient text-white': isSent(msg), 'border border-solid border-transparent bg-white': !isSent(msg)}">
                    <span>{{ decryptMessage(msg.message) }}</span><br/>
                    <span style="font-size: 8px;">{{ localTime(msg.createdAt) }}</span>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { encrypt, decrypt } from '@/utils/e2e/EncryptDecrypt.js';
import constants from '@/constants.js';

export default{
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      constants
    }
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    userData() {
      return this.$store.state.users.data;
    },
    chatData () {
      // // console.log(this.userId);
      return this.$store.getters['userChat/chatDataOfUser'](this.userId)
    },
    activeUserImg () {
      return this.$store.state.AppActiveUser.photoURL
    },
    senderImg () {
      return (isSentByActiveUser) => {
        if (isSentByActiveUser) return this.$store.state.AppActiveUser.photoURL
        else return this.$store.getters['userChat/contact'](this.userId).photoURL
      }
    },
    hasSentPreviousMsg () {
      return (last_sender, current_sender) => last_sender === current_sender
    }
  },
  methods: {
    decryptMessage(message) {
      // // console.log(message);
      return decrypt(message);
    },
    isSent(msg) {
      return msg.sentByUserId === this.userData._id
    },
    isSameDay (time_to, time_from) {
      const date_time_to = new Date(Date.parse(time_to))
      const date_time_from = new Date(Date.parse(time_from))
      return date_time_to.getFullYear() === date_time_from.getFullYear() &&
                date_time_to.getMonth() === date_time_from.getMonth() &&
                date_time_to.getDate() === date_time_from.getDate()
    },
    toDate (time) {
      // const locale = 'en-us'
      const locale = navigator.language || navigator.userLanguage || navigator.systemLanguage || 'en-us';
      const date_obj = new Date(Date.parse(time))
      const monthName = date_obj.toLocaleString(locale, {
        month: 'short'
      })
      return `${date_obj.getDate()  } ${   monthName}`
    },
    localDate (date) {
      return (new Date(date)).toLocaleDateString();
    },
    localTime (date) {
      return (new Date(date)).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
    },
    scrollToBottom () {
      this.$nextTick(() => {
        this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
      })
    }
  },
  updated () {
    this.scrollToBottom()
  },
  mounted () {
    this.scrollToBottom()
  }
}
</script>


<style scoped>
.ete-msg {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  padding: 5%;
}

.ete-msg p {
  width: 350px;
}
</style>